// ABOUTME: Initializes select2 dropdown on connect.
// ABOUTME: Auto-runs when Turbo Stream inserts an element with data-controller="select2".

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).select2()
  }

  disconnect() {
    if ($(this.element).data('select2')) {
      $(this.element).select2('destroy')
    }
  }
}
